function initJudgeMeCustomizations() {
  const currentReplyName = "jollimate dev store";
  const publicReplyName = "Jollimate";
  const replierSelector = ".jdgm-rev__replier";
  const replierWrapperSelector = ".jdgm-rev__replier-wrapper";
  const reviewSelector = ".jdgm-rev";
  const styleId = "custom-judgeme-styles";

  function normalizeText(value) {
    return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function injectJudgeMeStyles() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      /* Ẩn badge mặc định của Judge.me */
      .jdgm-rev__buyer-badge,
      .jdgm-rev .jdgm-rev__icon:after {
        display: none !important;
      }
      .custom-jdgm-avatar-wrapper {
        position: relative !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        overflow: visible !important;
        vertical-align: middle !important;
      }
      /* Dấu tick tròn màu xanh ngọc ở góc trên bên phải avatar */
      .custom-jdgm-verified-tick {
        position: absolute !important;
        top: -3px !important;
        right: -4px !important;
        width: 14px !important;
        height: 14px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        z-index: 10 !important;
        pointer-events: none !important;
        line-height: 1 !important;
      }
      .custom-jdgm-verified-tick svg {
        width: 100% !important;
        height: 100% !important;
        display: block !important;
      }
    `;
    document.head.appendChild(style);
  }

  function getAvatarContainer(review) {
    return (
      review.querySelector(".jdgm-rev__icon, .jdgm-rev__avatar, .jdgm-rev__pic, .jdgm-rev__author-avatar") ||
      review.querySelector(".jdgm-rev__header > :first-child")
    );
  }

  function applyCyanVerifiedBadge(review) {
    if (!review.getAttribute("data-verified-buyer")) {
      review.setAttribute("data-verified-buyer", "buyer");
    }

    // Xóa triệt để các badge thừa nếu có
    const existingTicks = review.querySelectorAll(".custom-jdgm-verified-tick");
    if (existingTicks.length > 1) {
      for (let i = 1; i < existingTicks.length; i++) {
        existingTicks[i].remove();
      }
      return;
    }
    if (existingTicks.length === 1) {
      return;
    }

    const avatarContainer = getAvatarContainer(review);
    if (!avatarContainer) return;

    avatarContainer.classList.add("custom-jdgm-avatar-wrapper");

    const tick = document.createElement("span");
    tick.className = "custom-jdgm-verified-tick";
    tick.setAttribute("aria-hidden", "true");
    tick.innerHTML = `
      <svg viewBox="0 0 16 16" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#38c2de"/>
        <path d="M4.5 8.2L6.8 10.5L11.5 5.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    avatarContainer.appendChild(tick);
  }

  function syncAllReviewBadges(root = document) {
    const allReviews = Array.from(document.querySelectorAll(reviewSelector));
    if (!allReviews.length) return;

    allReviews.forEach((review) => {
      applyCyanVerifiedBadge(review);
    });
  }

  function updateReplierName(root = document) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll(replierSelector).forEach((element) => {
      if (normalizeText(element.textContent) === currentReplyName) {
        element.textContent = publicReplyName;
      }
    });
  }

  function removeReplierPrefix(root = document) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll(replierWrapperSelector).forEach((wrapper) => {
      wrapper.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;

        node.nodeValue = node.nodeValue.replace(/^\s*>>\s*/, "");
      });
    });
  }

  function updateJudgeMeElements(root = document) {
    updateReplierName(root);
    removeReplierPrefix(root);
    syncAllReviewBadges(root);
  }

  injectJudgeMeStyles();
  updateJudgeMeElements();

  [200, 500, 1000, 2000, 3500, 5500].forEach((delay) => {
    window.setTimeout(updateJudgeMeElements, delay);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(replierSelector) || node.matches?.(reviewSelector) || node.querySelector?.(reviewSelector)) {
          updateJudgeMeElements(node.parentElement || document);
          return;
        }

        updateJudgeMeElements(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initJudgeMeCustomizations);
} else {
  initJudgeMeCustomizations();
}
